import { render } from "./container-usage.vue?vue&type=template&id=b84fadd0&scoped=true"
import script from "./container-usage.vue?vue&type=script&lang=js"
export * from "./container-usage.vue?vue&type=script&lang=js"

import "./container-usage.vue?vue&type=style&index=0&id=b84fadd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84fadd0"]])

export default __exports__